import React, { useState } from "react";
import { Fab, TextField, TextareaAutosize, Grid } from "@material-ui/core";
import { ArrowBack, GetApp } from "@material-ui/icons";
import { Link } from "react-router-dom";
import QRcode from "qrcode.react";

function QRgenerator() {
  const [qr, setQr] = useState("CodeSuite");
  const handleChange = (event) => {
    setQr(event.target.value);
  };
  // const downloadQR = () => {
  //     const canvas = document.getElementById("myqr");
  //     const pngUrl = canvas
  //       .toDataURL("image/png")
  //       .replace("image/png", "image/octet-stream");
  //     let downloadLink = document.createElement("a");
  //     downloadLink.href = pngUrl;
  //     downloadLink.download = "myqr.png";
  //     document.body.appendChild(downloadLink);
  //     downloadLink.click();
  //     document.body.removeChild(downloadLink);
  // };

  return (
    <div className="mb-8">
      {/*     <div style={{ marginTop: 30 }}>
        <TextField
          onChange={handleChange}
          style={{ width: 320 }}
          value={qr}
          label="QR content"
          size="large"
          variant="outlined"
          color="primary"
        />
      </div>*/}

      <div className="m-auto text-center inline-block">
        <div className="mt-8 pt-8 text-2xl bg-white font-semibold font-Montserrat text-black">
          QR code Scanning
        </div>
        {qr ? (
          <QRcode
            className="content-center"
            id="myqr"
            value={qr}
            size={380}
            includeMargin={true}
          />
        ) : (
          <p>No QR code preview</p>
        )}
      </div>
      <div className="mt-8 mb-8 font-semibold font-Montserrat text-red-700">
        Value of QR:
      </div>
      <div className="mt-8 mb-8 ">
        <TextField
          className="bg-white mb-8"
          style={{ width: 380 }}
          value={qr}
          defaultValue={qr}
          size="large"
        />
      </div>
      {/* <div className='ml-auto'>
                {
                    qr ? 
                    <Grid container>
                        <Grid item xs={10}>
                        <input type='text' defaultValue={qr} value={qr} ></input>
                        <TextareaAutosize
                            style={{fontSize:18, width:250, height:100}}
                            rowsMax={4}
                            defaultValue={qr}
                            value={qr}
                        />
                        </Grid>
                        <Grid item xs={2}>
                        <Fab onClick={downloadQR} style={{marginLeft:10}} color="primary">
                            <GetApp/>
                        </Fab>
                        </Grid> 
                    </Grid> :
                    ''
                }
            </div>*/}
    </div>
  );
}

export default QRgenerator;
